import { c as getElement, r as registerInstance, d as createEvent, h } from './index-34617187.js';
import { isEmpty, isNil, compact, get } from 'lodash-es';
import moment from 'moment';
import { m as mapDateFormat, k as disabledDatesHandler, h as dateBoundHandler, b as isValidDateFormat, S as SPACE_REGEX, a as strToDateObj, s as strToMoment, T as TODAY_RELATIVE, i as isRelativeValue, e as getLeftLabelOffset, c as getFocusCss, o as isHelperKeys, v as validKey, n as initOverlay, g as getSeparatorRegex, f as updateFormatDate, u as updateSeparator } from './bxf-date-input.utils-c1de678d.js';
import { a as BxfDatePickerDateFormatEnum, b as BxfDatePickerSeparatorsEnum } from './bxf-date-picker-separators.enum-a0b9baeb.js';
import { a as BxfDatePickerConstants, B as BxfDateInputConstants } from './bxf-date-picker.constants-9ea62086.js';
import { d as defaultValidator, g as getValidator, i as isRequiredValidator, a as defaultDateRangeValidator } from './validator.factory-71476736.js';
import { u as uuidv4 } from './uuidv4-06ebe3ff.js';
import { B as BxfDefaultState } from './bxf-default-store-cc52e0b9.js';
import { a as BxfDynamicPositionEnum } from './bxf-chat-canvas.constants-0879888b.js';
import { b as BxfOverlayTriggerEnum } from './overlay-controller-8ff05c99.js';
import { B as BxfFormValidationType } from './form-validation-type.enum-a74832c5.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './i18n.config-355137b0.js';
import { g as getParentOverlayContainer } from './get-parent-overlay-container-5aaa107a.js';
import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';
import { R as Role } from './role.enum-c3c8cd89.js';
import { l as createSelector, O as AriaAttr, P as WindowEventMap } from './bxf-utils-3908c3c5.js';
import { B as BxfIconTypeEnum } from './bxf-icon.type-4afcd2ad.js';
import { F as FocusIndexManager } from './focus-index-manager-d376b5ea.js';
import { H as HasPopupValue } from './has-popup-value.enum-d8e40cc4.js';
import { B as BxfButtonTypeEnum } from './button-type.enum-3452e5b6.js';
import { B as BxfDateRangePickerConstants } from './bxf-date-range-picker.constants-bc83720f.js';
import { F as FocusSource } from './focus-source.enum-fe7089b3.js';
import './bxf-text-input.utils-6d1dfc5c.js';
import './focus-trap-023cd6d1.js';
import './query-selector-shadow-dom-dc946919.js';
import './overlay-dropdown-controller-d9d1cfbe.js';
import 'moment/moment';
import './bxf-type-ahead.constants-d006f018.js';
import 'dompurify';

const bxfDatePickerCss = "button.sc-bxf-date-picker:hover,a.sc-bxf-date-picker:hover,input[type=radio].sc-bxf-date-picker:hover,input[type=checkbox].sc-bxf-date-picker:hover,input[type=radio].sc-bxf-date-picker:checked:hover,input[type=checkbox].sc-bxf-date-picker:checked:hover,svg.sc-bxf-date-picker:hover{cursor:pointer}svg[disabled].sc-bxf-date-picker:hover,button[disabled].sc-bxf-date-picker:hover,label[disabled].sc-bxf-date-picker:hover,input[type=checkbox].sc-bxf-date-picker:disabled:hover,input[type=radio].sc-bxf-date-picker:disabled:hover,input[type=checkbox].sc-bxf-date-picker:checked:disabled:hover,input[type=radio].sc-bxf-date-picker:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-date-picker{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-date-picker__left-label-container.sc-bxf-date-picker{display:flex;flex-direction:row}.bxf-date-picker.sc-bxf-date-picker{display:flex;background-color:var(--date-picker__background-color)}.bxf-date-picker--small.sc-bxf-date-picker{display:flex;align-items:flex-start;flex-direction:row}.bxf-date-picker--small.sc-bxf-date-picker *.sc-bxf-date-picker{display:flex}.bxf-date-picker--focused-keyboard.sc-bxf-date-picker{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-date-picker__label.sc-bxf-date-picker{padding-bottom:0.5rem;font-size:0.8125rem;max-width:fit-content;min-width:fit-content;width:fit-content;color:var(--primary-text__color);flex:1 1 0%;line-height:1rem;white-space:nowrap}.bxf-date-picker__label--compact.sc-bxf-date-picker{padding-bottom:0.25rem}.bxf-date-picker__label-left.sc-bxf-date-picker,.bxf-date-picker__label-left--compact.sc-bxf-date-picker{display:inline-flex;align-items:center;padding-right:0.75rem;padding-bottom:0}.bxf-date-picker__label-left--compact.sc-bxf-date-picker{padding-right:0.5rem}.bxf-date-picker__message.sc-bxf-date-picker,.bxf-date-picker__message--success.sc-bxf-date-picker,.bxf-date-picker__message--warning.sc-bxf-date-picker,.bxf-date-picker__message--error.sc-bxf-date-picker{display:block;font-size:0.8125rem;line-height:1.2307692308;padding-top:0.25rem}.bxf-date-picker__message--error.sc-bxf-date-picker{color:var(--text__color--error)}.bxf-date-picker__message--success.sc-bxf-date-picker{color:var(--text__color--success)}.bxf-date-picker__start-date-picker.sc-bxf-date-picker{margin-right:0.5rem}.bxf-date-picker__input.sc-bxf-date-picker{border:0.0625rem solid var(--form-element__border-color);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-focused.sc-bxf-date-picker{border:0.0625rem solid var(--focus-highlight_border-color);background-color:var(--focus-highlight_background-color);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-invalid.sc-bxf-date-picker{border:0.0625rem solid var(--form-element__border-color--error);background-color:var(--form-element__background-color--error);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-success.sc-bxf-date-picker{border:0.0625rem solid var(--form-element__border-color--success);background-color:var(--form-element__background-color--success);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-disabled.sc-bxf-date-picker{border:none;background-color:var(--input-box__background-color--disabled);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-warning.sc-bxf-date-picker{border:0.0625rem solid var(--form-element__border-color--warning);background-color:var(--form-element__background-color--warning);border-radius:0.125rem;display:inline-flex}.bxf-date-picker--container-focus-bottom.sc-bxf-date-picker{border-bottom:0.0625rem solid var(--input__border-bottom-color_focus) !important}.bxf-date-picker__mid.sc-bxf-date-picker{display:grid;margin:auto 0.5rem auto 0.5rem;align-content:center}.bxf-date-picker__mid--small.sc-bxf-date-picker{margin-top:1.75rem;margin-right:0.5rem;font-size:0.8125rem;color:var(--primary-text__color)}.bxf-date-picker__mid--stacked.sc-bxf-date-picker{margin-top:2rem}.bxf-date-picker__mid--large.sc-bxf-date-picker{margin-top:3rem;margin-right:1.25rem}.bxf-date-picker__large--stacked.sc-bxf-date-picker{margin-top:3rem}.bxf-date-picker__mid--small-stacked.sc-bxf-date-picker{margin-top:1.75rem}.bxf-date-picker__start-date-picker--small.sc-bxf-date-picker{margin-right:0.5rem}.bxf-date-picker__stacked.sc-bxf-date-picker{flex-direction:column}.bxf-date-picker__stacked-start.sc-bxf-date-picker{margin-bottom:0.75rem}.bxf-date-picker__mid--condensed.sc-bxf-date-picker{margin-top:0.375rem;line-height:1.25rem}.bxf-date-picker__mid--small-condensed.sc-bxf-date-picker{margin-top:0.25rem}.bxf-date-picker__mid--large-condensed.sc-bxf-date-picker{margin-top:0.75rem}.bxf-date-picker__start-container.sc-bxf-date-picker{display:flex}.bxf-date-picker__start-date-picker--margin-right.sc-bxf-date-picker,.bxf-date-picker__mid--stacked.sc-bxf-date-picker,.bxf-date-picker__large--stacked.sc-bxf-date-picker,.bxf-date-picker__mid--small-stacked.sc-bxf-date-picker{margin-right:0;padding-bottom:0.0625rem;border-radius:0.125rem}.bxf-date-picker-range__date-input.sc-bxf-date-picker{margin:0}.bxf-date-picker__input--focus.sc-bxf-date-picker{border-bottom:0.0625rem solid var(--input__border-bottom-color_focus)}.bxf-date-picker__calendar_button--container.sc-bxf-date-picker{margin:auto 0 auto -0.75rem}.bxf-date-picker__calendar_button.sc-bxf-date-picker{display:flex;align-content:center;padding:0 0.25rem}.bxf-date-picker__label--required.sc-bxf-date-picker{padding-left:0.25rem;color:var(--text__color--error);font-size:1rem;line-height:1.1875;padding-bottom:0.25rem;float:right}.bxf-date-input__instructional-text.sc-bxf-date-picker{color:var(--secondary-text__color);font-size:0.8125rem;padding-bottom:0.5rem}.bxf-date-input__label--disabled.sc-bxf-date-picker{color:var(--disabled-text__color)}";
const BxfDatePickerStyle0 = bxfDatePickerCss;

const { CONTAINER, DISABLED_LABEL: DISABLED_LABEL$1, FOCUS_BOTTOM_BORDER, DISABLED_CONTAINER: DISABLED_CONTAINER$1, CALENDAR_BUTTON_LABEL, SUFFIX_BUTTON, DEFAULT_US: DEFAULT_US$1, BXF_DATE_PICKER, DEFAULT_RELATIVE_DATE, CALENDAR_BUTTON: CALENDAR_BUTTON$1, INVALID_CONTAINER: INVALID_CONTAINER$1, WARNING_CONTAINER: WARNING_CONTAINER$1, SUCCESS_CONTAINER: SUCCESS_CONTAINER$1, ERROR_MESSAGE: ERROR_MESSAGE$1, LEFT_LABEL_CONTAINER: LEFT_LABEL_CONTAINER$1, WARNING_MESSAGE: WARNING_MESSAGE$1, SUCCESS_MESSAGE: SUCCESS_MESSAGE$1, CALENDAR_BUTTON_CONTAINER: CALENDAR_BUTTON_CONTAINER$1, DATE_PICKER_CONTAINER, DATE_INPUT_REQUIRED, LABEL_CONTAINER, LEFT_LABEL: LEFT_LABEL$1, LEFT_LABEL_COMPACT: LEFT_LABEL_COMPACT$1, LABEL: LABEL$1, LABEL_COMPACT: LABEL_COMPACT$1, SPECIFIC_DATE_REGEX, } = BxfDatePickerConstants.STRING;
const BxfDatePicker = class {
    get host() { return getElement(this); }
    overlay;
    dateInputRef;
    datePickerRef;
    calendarRef;
    calendarButtonRef;
    textInputElement;
    defaultValidator = defaultValidator;
    i18n;
    descriptionId = uuidv4();
    labelId = uuidv4();
    calendarButtonId = uuidv4();
    datePickerId = uuidv4();
    calendarId = uuidv4();
    dateFormatChangeHandler(newValue) {
        this.dateFormat = mapDateFormat(newValue);
    }
    /**
     * Handles the change event for the `disabledDates` property.
     * @param newValue - The new value of the `disabledDates` property.
     */
    disabledDatesChangeHandler(newValue) {
        disabledDatesHandler(newValue, this.separator, this.dateFormat);
    }
    displayDateFormatChangeHandler(newValue) {
        this.displayDateFormat = mapDateFormat(newValue);
    }
    eventDateSeparatorChangeHandler(newValue) {
        if (isEmpty(newValue))
            this.eventDateSeparator = this.separator;
    }
    /**
     * Handles the change in the isOpen property and performs removes the calendar overlay when false.
     * @param newValue - The new value of the isOpen prop
     */
    calendarOpenHandler(newValue) {
        /* istanbul ignore else */
        if (!newValue) {
            /* istanbul ignore else */
            if (this.overlay) {
                this.overlay.close();
                this.overlay = null;
            }
            this.close();
            this.calendarClosed.emit();
        }
        else if (this.isDisabled) {
            this.isOpen = false;
        }
    }
    /**
     * Handles the change in the `maxDate` or `maxYear` property and updates the
     * `maxDateSelectable` property accordingly which is in a format `bxf-calendar`
     * can comprehend
     */
    maxDateHandler() {
        this.maxDateSelectable = dateBoundHandler(this.maxDate, this.maxYear, this.separator, this.dateFormat, false);
    }
    /**
     * Handles the change in the `minDate` or `minYear` property and updates the
     * `minDateSelectable` property accordingly which is in a format `bxf-calendar`
     * can comprehend
     */
    minDateHandler() {
        this.minDateSelectable = dateBoundHandler(this.minDate, this.minYear, this.separator, this.dateFormat, true);
    }
    separatorChangeHandler() {
        if (isEmpty(this.eventDateSeparator))
            this.eventDateSeparator = this.separator;
    }
    valueChangedHandler(newValue) {
        this.removeClockTimeFromValue(newValue);
        this.setValidState(newValue);
    }
    /**
     * This event is emitted on focus change of text input
     */
    blurChanged;
    /**
     * This event is emitted when calendar overlay is closed
     */
    calendarClosed;
    /**
     * This event is emitted when calendar overlay is opened
     */
    calendarOpened;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted on change of start value via calendar
     */
    calendarValueChanged;
    /**
     * This event is emitted when date (day) changes
     */
    dateChanged;
    /**
     * This event is emitted when a new date format is selected in settings panel
     */
    dateFormatSelected;
    /**
     * This event is emitted when date (day) is selected
     */
    dateSelected;
    /**
     * This event is emitted on focus change of text input
     */
    focusChanged;
    /**
     * This event is emitted when end calendar's footer is clicked
     */
    footerClicked;
    /**
     * This event is emitted on change of value for form validation
     */
    formValueChanged;
    /**
     * This event is emitted when month changes via select in calendar
     */
    monthChanged;
    /**
     * This event is emitted when a new separator is selected in settings panel
     */
    separatorSelected;
    /**
     * This event is emitted when a shortcut is clicked
     */
    shortcutClicked;
    /**
     * This event is emitted when calendar button is clicked
     */
    suffixChanged;
    /**
     * This event is emitted when an item in the today button inline menu is selected.
     */
    todayButtonMenuItemClicked;
    /**
     * This event is emitted on change of value inside date picker
     */
    valueChanged;
    /**
     * This event is emitted when year changes via select in calendar
     */
    yearChanged;
    /**
     * Public method that would clear current value and reset it to mask
     */
    async clearValue() {
        this.value = '';
        this.dateObj = [];
    }
    /**
     * Public method that closes the calendar overlay
     */
    async close() {
        // Prevents bug where calendar cannot be reopened after closing with the calendar button
        setTimeout(() => (this.isOpen = false), 0);
    }
    /**
     * This method allows for focusing on the component's start text input element
     */
    async focusInput() {
        await this.dateInputRef?.focusInput();
        this.isFocused = true;
    }
    /**
     * Public method that opens the calendar overlay
     */
    async open() {
        this.isOpen = true;
    }
    /**
     * Used to set dateFormat
     * @param newValue - string value that represents a date format
     */
    async setDateFormatValue(newValue) {
        // if newValue is not a key of the enum, undefined will be returned
        const dateFormat = BxfDatePickerDateFormatEnum[newValue];
        /* istanbul ignore else */
        if (newValue && dateFormat) {
            this.initDateFormat = dateFormat;
            this.dateFormat = dateFormat;
            this.displayDateFormat = dateFormat;
        }
    }
    /**
     * Used to set value for forms
     * @param newValue - string value that represents a date
     */
    async setValue(newValue) {
        if (typeof newValue !== 'string')
            return;
        this._setValue(newValue);
    }
    /**
     * Used to toggle disable for forms
     * @param action - boolean value that represents whether to disable or enable the component
     */
    async toggleDisable(action) {
        this.isDisabled = action;
    }
    /**
     * Public method to initialize validators on date-picker value
     * @param value - string value that represents a date
     */
    async validate(value) {
        if (this.validator) {
            this.defaultValidator = getValidator(this.validator);
            this.isValid = isRequiredValidator(this.validator)
                ? this.defaultValidator.validate(!isEmpty(value) &&
                    isValidDateFormat(value, this.separator, this.dateFormat))
                : this.defaultValidator.validate(value);
            this.errorMessage = this.defaultValidator.errorMessage;
        }
    }
    /**
     * Function checks if value is invalid when used for required validation in forms
     * @param newValue - string value that represents a date
     * @returns {Promise<boolean>} returns true if value is not provided and required validator should return error
     */
    async validateForRequired(newValue) {
        // should return true if value is not provided and required validator should return error
        return Promise.resolve(isNil(newValue) || newValue === '');
    }
    /**
     * Opens the calendar overlay and emits the `calendarOpened` event.
     */
    openCalendar() {
        this.overlay?.openOverlayWithPosition();
        this.calendarOpened.emit();
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.blurChanged = createEvent(this, "blurChanged", 7);
        this.calendarClosed = createEvent(this, "calendarClosed", 7);
        this.calendarOpened = createEvent(this, "calendarOpened", 7);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.calendarValueChanged = createEvent(this, "calendarValueChanged", 7);
        this.dateChanged = createEvent(this, "dateChanged", 7);
        this.dateFormatSelected = createEvent(this, "dateFormatSelected", 7);
        this.dateSelected = createEvent(this, "dateSelected", 7);
        this.focusChanged = createEvent(this, "focusChanged", 7);
        this.footerClicked = createEvent(this, "footerClicked", 7);
        this.formValueChanged = createEvent(this, "formValueChanged", 7);
        this.monthChanged = createEvent(this, "monthChanged", 7);
        this.separatorSelected = createEvent(this, "separatorSelected", 7);
        this.shortcutClicked = createEvent(this, "shortcutClicked", 7);
        this.suffixChanged = createEvent(this, "suffixChanged", 7);
        this.todayButtonMenuItemClicked = createEvent(this, "todayButtonMenuItemClicked", 7);
        this.valueChanged = createEvent(this, "valueChanged", 7);
        this.yearChanged = createEvent(this, "yearChanged", 7);
        this.calendarTodayButtonMenuItemClicked = false;
        this.dateObj = [];
        this.hasKeyboardFocus = false;
        this.isFocused = false;
        this.initDateFormat = undefined;
        this.inputClicked = false;
        this.maxDateSelectable = undefined;
        this.minDateSelectable = undefined;
        this.type = undefined;
        this.assistiveText = undefined;
        this.calendarI18nKeys = undefined;
        this.calendarNote = undefined;
        this.calendarSettingsI18nKeys = undefined;
        this.dateInputI18nKeys = undefined;
        this.closeCalendarOnBlur = true;
        this.customDateMarkerA = {};
        this.customDateMarkerB = {};
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.dateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
        this.defaultPopoverHeader = undefined;
        this.disabledDates = undefined;
        this.disableWeekends = false;
        this.displayDateFormat = BxfDatePickerDateFormatEnum.DD_MMM_YYYY;
        this.errorMessage = undefined;
        this.eventData = {};
        this.eventDateSeparator = undefined;
        this.filterMonths = false;
        this.footerLabel = DEFAULT_US$1;
        this.footerShortcutData = [];
        this.hasDateFormatSettings = true;
        this.hasFooterLabel = true;
        this.hasFooterSettings = true;
        this.hasMarkerKey = true;
        this.hasSeparatorSettings = true;
        this.hasTodayInFooter = true;
        this.hideDatesOutsideActiveMonth = false;
        this.hideInactiveDateDetails = false;
        this.holidays = {};
        this.initActiveMonth = undefined;
        this.initActiveYear = undefined;
        this.initWithToday = false;
        this.instructionalText = undefined;
        this.isCompact = BxfDefaultState.isCompact;
        this.isDisabled = false;
        this.isDisplayDateAllCaps = false;
        this.isFooterDisabled = false;
        this.isFooterVisible = true;
        this.isLeftLabel = false;
        this.isOpen = false;
        this.isReadOnly = false;
        this.isRelativeDate = false;
        this.isRequired = false;
        this.isSuccess = false;
        this.isTodayHighlighted = true;
        this.isTracking = false;
        this.isValid = true;
        this.i18nKeys = undefined;
        this.keepMouseFocus = false;
        this.keepRelativeDate = false;
        this.keepTodayEnabled = false;
        this.label = undefined;
        this.maxDate = undefined;
        this.maxYear = undefined;
        this.minDate = undefined;
        this.minYear = undefined;
        this.namespaceI18n = undefined;
        this.overridePlacement = BxfDynamicPositionEnum.BOTTOM_LEFT;
        this.relativeDateValue = DEFAULT_RELATIVE_DATE;
        this.settingsSelectData = [];
        this.showInputGuide = true;
        this.showMarkerPopovers = false;
        this.showTodayButtonAsShortcut = false;
        this.size = 'regular';
        this.skipValidation = false;
        this.separator = BxfDatePickerSeparatorsEnum.DASH;
        this.sourceElementCustomClass = [];
        this.successMessage = null;
        this.targetElementCustomClass = [];
        this.todayButtonMenuData = [];
        this.trackingData = undefined;
        this.trigger = BxfOverlayTriggerEnum.PRESSED;
        this.validationType = BxfFormValidationType.ERROR;
        this.validator = undefined;
        this.value = undefined;
        this.setIsOpen = this.setIsOpen.bind(this);
        this.shouldOpen = this.shouldOpen.bind(this);
        this.shouldClose = this.shouldClose.bind(this);
        this.datePickerRefHandler = this.datePickerRefHandler.bind(this);
        this.iconRefHandler = this.iconRefHandler.bind(this);
        this.handleCalendarValueChange =
            this.handleCalendarValueChange.bind(this);
        this.handleInputValidity = this.handleInputValidity.bind(this);
        this.dateInputRefHandler = this.dateInputRefHandler.bind(this);
        this.handleFooterButtonOnClick =
            this.handleFooterButtonOnClick.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.calendarButtonClickHandler =
            this.calendarButtonClickHandler.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
    }
    componentWillLoad() {
        this.dateFormat = mapDateFormat(this.dateFormat);
        this.displayDateFormat = mapDateFormat(this.displayDateFormat);
        this.initValue();
        if (isEmpty(this.eventDateSeparator))
            this.eventDateSeparator = this.separator;
        /* istanbul ignore else */
        this.disabledDates = disabledDatesHandler(this.disabledDates, this.separator, this.dateFormat);
        this.initDateFormat = this.dateFormat;
        /* istanbul ignore else */
        if (!isNil(this.value)) {
            this.validate(this.value);
        }
        this.setDateObject();
        this.minDateHandler();
        this.maxDateHandler();
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
    }
    /**
     * Function that sets the initial value of the component, and checks if the value is required
     * Needed for fast loading the component. Replaces the removed isFastLoad property.
     */
    initValue() {
        this.removeClockTimeFromValue();
        if (this.validator) {
            this.isRequired = isRequiredValidator(this.validator);
        }
        if (!isEmpty(this.value)) {
            (async () => {
                await this.validate(this.value);
            })();
        }
    }
    /**
     * Function that removes the clock time from the value
     * @param date - string value that represents a date
     */
    removeClockTimeFromValue(date = this.value) {
        if (!date)
            return;
        const dateWithoutClockTime = date.match(SPECIFIC_DATE_REGEX);
        if (dateWithoutClockTime &&
            date !== dateWithoutClockTime[0] &&
            isValidDateFormat(date, this.separator, this.dateFormat)) {
            this.value = dateWithoutClockTime[0];
        }
    }
    /**
     * Function will set the value isValid after first render
     * @param value string value that represents a date
     */
    async componentDidLoad() {
        /* istanbul ignore else */
        this.value && (await this.setValidState(this.value));
    }
    /**
     * Ensures that the overlay was close before the component is removed from the DOM
     */
    disconnectedCallback() {
        this.isOpen = false;
        this.i18n?.destroyTranslations();
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    /**
     * Function that returns the value in the initial format set by developer
     * @param date - string date value
     * @returns {string} input date format when first rendered
     */
    toInitialDateFormat(date) {
        if (!this.initDateFormat || !this.separator) {
            return date; // handling undefined values by returning the input date
        }
        const dateMoment = moment(date, BxfDatePickerDateFormatEnum.DD_MM_YYYY);
        return dateMoment.isValid()
            ? moment(date, BxfDatePickerDateFormatEnum.DD_MM_YYYY).format(this.initDateFormat.replace(SPACE_REGEX, this.eventDateSeparator))
            : date;
    }
    /**
     * Converts the date value to a general date object to set calendar
     * @param value - string value that represents a date
     */
    setDateObject(value = this.value) {
        this.dateObj = this.isValid
            ? strToDateObj(value, this.separator, this.dateFormat)
            : null;
    }
    /**
     * Binds new values to the picker and validates the new value
     * @param value - the date of the range to be validated
     */
    async setValidState(value) {
        /* istanbul ignore else */
        if (this.skipValidation || (!this.isRequired && isEmpty(value))) {
            this.isValid = true;
        }
        else if (this.calendarRef) {
            const dateMoment = strToMoment(value, this.separator, this.dateFormat);
            const isDisabled = await this.calendarRef.isDisabledDate(dateMoment);
            this.isValid =
                value?.startsWith(TODAY_RELATIVE) ||
                    (dateMoment?.isValid() && !isDisabled);
        }
        this.setDateObject(this.value);
    }
    /**
     * Emits the value changed event and the form value changed event.
     * @param value - The new value of the date picker.
     */
    emitValueChanged(value) {
        /* istanbul ignore else */
        if (this.value !== value) {
            const dateMoment = strToMoment(value, this.separator, this.dateFormat);
            const formattedValue = !dateMoment.isValid() || isRelativeValue(value)
                ? value
                : dateMoment.format(this.initDateFormat.replace(SPACE_REGEX, this.eventDateSeparator));
            this.valueChanged.emit({
                value: formattedValue,
                dateMoment,
                dateObject: dateMoment?.toDate(),
                srcEvent: null,
                eventData: this.eventData,
            });
            this.formValueChanged.emit({
                value: formattedValue || undefined,
                srcEvent: null,
                eventData: this.eventData,
            });
            this.setDateInput(value);
        }
    }
    /**
     * Used to set value for forms
     * @param newValue - string value that represents a date
     */
    async _setValue(newValue) {
        /* istanbul ignore else */
        if (isValidDateFormat(newValue, this.separator, this.dateFormat)) {
            this.setDateInput(newValue
                ? newValue.match(SPECIFIC_DATE_REGEX)?.[0] || newValue
                : '');
        }
    }
    /**
     * Returns the CSS classes for the container element of the date picker component.
     * @returns {string} The CSS classes for the container element.
     */
    get containerClasses() {
        return `${BXF_DATE_PICKER} ${this.inputContainerClass}`;
    }
    /**
     * Function that returns the date format with the appropriate separator
     */
    get dateFormatWithSeparator() {
        if (!this.dateFormat || !this.separator) {
            return ''; //  handling undefined values by returning a default
        }
        return this.dateFormat.replace(SPACE_REGEX, this.separator);
    }
    /**
     * Function that returns the left label offset and adjusts the label, instructional text and validation message to align with the input
     * @returns {string} The left label offset in px
     **/
    get leftLabelOffset() {
        return `${getLeftLabelOffset(this.label, this.isCompact, this.isLeftLabel, this.isRequired)}px`;
    }
    /**
     * Returns the CSS class for the input container based on the current state of the component.
     * @returns {string} The CSS class for the input container.
     */
    get inputContainerClass() {
        /* istanbul ignore else */
        if (this.isDisabled || this.isReadOnly) {
            return DISABLED_CONTAINER$1;
        }
        /* istanbul ignore else */
        if (!this.isValid) {
            return this.validationType === BxfFormValidationType.ERROR
                ? INVALID_CONTAINER$1
                : WARNING_CONTAINER$1;
        }
        /* istanbul ignore else */
        if (this.isValid && this.isSuccess && this.value) {
            return SUCCESS_CONTAINER$1;
        }
        return this.isFocused || this.isOpen
            ? `${getFocusCss(this.hasKeyboardFocus)} ${FOCUS_BOTTOM_BORDER}`
            : CONTAINER;
    }
    /**
     * Function that returns the CSS class for the label
     * @returns {string} The CSS class(es) for the label
     **/
    get labelCss() {
        const isDisabled = this.isDisabled ? DISABLED_LABEL$1 : '';
        const isCompact = this.isCompact ? LABEL_COMPACT$1 : '';
        return `${isDisabled} ${LABEL$1} ${isCompact} ${this.leftLabelCss}`;
    }
    /**
     * Function that returns the CSS class for the left label
     * @returns {string} The CSS class for the left label
     **/
    get leftLabelCss() {
        /* istanbul ignore else */
        if (this.isLeftLabel) {
            return this.isCompact ? LEFT_LABEL_COMPACT$1 : LEFT_LABEL$1;
        }
        return '';
    }
    /**
     * Sets the icon reference handler.
     * @param el - The HTML element representing the icon.
     */
    iconRefHandler(el) {
        this.calendarButtonRef = el;
        this.initOverlay();
    }
    /**
     * Sets the calendar reference handler.
     * @param el - The HTML element representing the calendar.
     */
    calendarRefHandler(el) {
        this.calendarRef = el;
        el && this.initOverlay();
    }
    /**
     * Sets the date picker reference handler.
     * @param el - The HTML element representing the date picker.
     */
    datePickerRefHandler(el) {
        /* istanbul ignore else */
        this.datePickerRef = el;
        el && this.initOverlay();
    }
    /**
     * Function that sets a reference to the date input element
     * @param el - The date input element
     * */
    async dateInputRefHandler(el) {
        /* istanbul ignore else */
        if (el) {
            this.dateInputRef = el;
            const inputContainer = await this.dateInputRef?.getInputContainerRef();
            this.textInputElement = inputContainer?.querySelector('input');
        }
    }
    /**
     * Function will tell user whether date is disabled or not the moment that
     * they type in the date. Allows for user to see date selection on opened calendar
     * before blur
     * @param event - KeyboardEvent
     * */
    async handleInputValidity(event) {
        const { value } = this.textInputElement;
        /* istanbul ignore else */
        if (isHelperKeys(event, value))
            return;
        event.stopPropagation();
        /* istanbul ignore else */
        if (validKey(event.key, value, this.initDateFormat)) {
            const tempMoment = moment(value, this.dateFormatWithSeparator);
            this.isValid =
                tempMoment.isValid() &&
                    !(await this.calendarRef.isDisabledDate(tempMoment));
            this.setDateObject(value);
        }
        else if (!this.isRelativeDate) {
            this.dateObj = [];
        }
    }
    /**
     *
     * Sets the value of the input to the todays date if not disabled
     * @param event - KeyboardEvent
     */
    handleFooterButtonOnClick(event) {
        event.stopPropagation();
        const { dateMoment, todayInFooter, isTodayValid } = event.detail;
        todayInFooter &&
            isTodayValid &&
            this.emitValueChanged(this.momentToString(dateMoment));
        this.footerClicked.emit(event.detail);
    }
    /**
     * Converts moment object to string date
     * @param dateMoment - moment object of the date selected
     */
    momentToString(dateMoment) {
        return dateMoment.format(this.dateFormatWithSeparator);
    }
    /**
     * Sets the value of the date input to the appropriate value or relativeDateValue prop
     * @param value - The new value for the date input.
     */
    setDateInput(value) {
        if ((!this.isRelativeDate || value) &&
            !value.startsWith(TODAY_RELATIVE)) {
            this.value = value;
        }
        else if (value?.startsWith(TODAY_RELATIVE) && value.length > 2) {
            this.relativeDateValue = value;
        }
    }
    /**
     * Sets the value of the `isOpen` property.
     * @param value - The new value for `isOpen`.
     */
    setIsOpen(value) {
        this.isOpen = value;
    }
    /**
     * Determines whether the date picker should be open.
     * @returns {boolean} `true` if the date picker should be open, `false` otherwise.
     */
    shouldOpen() {
        return !this.isDisabled || !this.isReadOnly;
    }
    /**
     * Determines whether the date picker should be closed.
     * The date picker should be closed if neither the input nor the calendar today button were clicked.
     * @returns {boolean} True if the date picker should be closed, false otherwise.
     */
    shouldClose() {
        const buttonClicked = this.calendarTodayButtonMenuItemClicked;
        this.calendarTodayButtonMenuItemClicked = false;
        return !this.inputClicked && !buttonClicked;
    }
    /**
     * Initializes the overlay for the date picker component.
     * @remarks
     * This method checks if the overlay needs to be initialized and then initializes it with the necessary parameters.
     */
    initOverlay() {
        const overlayProps = {
            host: this.host,
            ref: this.datePickerRef,
            calendarRef: this.calendarRef,
            calendarButtonRef: this.calendarButtonRef,
            overridePlacement: this.overridePlacement,
            shouldOpen: this.shouldOpen,
            shouldClose: this.shouldClose,
            keepMouseFocus: this.keepMouseFocus,
            useFocusVisible: true,
            trigger: this.trigger,
            setIsOpen: this.setIsOpen,
            sourceElementCustomClass: this.sourceElementCustomClass,
            targetElementCustomClass: this.targetElementCustomClass,
            parentContainer: getParentOverlayContainer(this.parentOverlayContainerSelector),
        };
        /* istanbul ignore else */
        !this.overlay && (this.overlay = initOverlay(overlayProps));
    }
    /**
     * Turn focus ring back on when tab pressed in calendar
     */
    keyDownHandler(event) {
        const focusKeys = [
            ...FocusIndexManager.ESC_KEYS,
            ...FocusIndexManager.HORIZONTAL_NAV_KEYS,
            ...FocusIndexManager.VERTICAL_NAV_KEYS,
            KeyboardEventKey.Home,
            KeyboardEventKey.End,
            KeyboardEventKey.Tab,
        ];
        /* istanbul ignore else */
        if (focusKeys.includes(event.key)) {
            /* istanbul ignore else */
            if (event.key === KeyboardEventKey.Enter) {
                this.isFocused = false;
                this.inputClicked = false;
            }
        }
    }
    /**
     * Handles the change of focus for the date picker component and sets the new value to the component when blurred
     * @param event - The custom event containing the focus change information.
     */
    handleFocusChange(event) {
        this.isFocused = event.type === 'focusChanged';
        if (!this.isFocused) {
            this.blurChanged.emit(event.detail);
            const { value } = this.textInputElement;
            this.emitValueChanged(value);
            !isRelativeValue(value) && this.setValidState(value);
        }
        else {
            this.focusChanged.emit(event.detail);
        }
    }
    /**
     * Function that renders the error or success message when necessary
     * @param isSuccess - Whether or not the message is a success message or an error message
     * @returns {string} The CSS class for the message rendered beneath the input.
     */
    getMessageCss(isSuccess = true) {
        /* istanbul ignore else */
        if (isSuccess) {
            return SUCCESS_MESSAGE$1;
        }
        return this.validationType === BxfFormValidationType.ERROR
            ? ERROR_MESSAGE$1
            : WARNING_MESSAGE$1;
    }
    /**
     * Function that renders a success or error message when necessary
     * - Renders the error message when the input is either disabled or failed dev's custom validation, and has a set error message.
     * - Renders the success messages when the input is not disabled, passed dev's custom validation, and has a set success message
     * @returns JSX.Element | null - The message to render beneath the input.
     */
    renderMessage() {
        const isInvalid = !this.isValid && !isEmpty(this.errorMessage);
        const isSuccess = this.isSuccess &&
            this.isValid &&
            this.dateObj?.length &&
            !isEmpty(this.successMessage);
        const message = isInvalid ? this.errorMessage : this.successMessage;
        return isInvalid || isSuccess ? (h("div", { style: { paddingLeft: this.leftLabelOffset }, class: this.getMessageCss(isSuccess) }, message)) : null;
    }
    /**
     * Render error or success message in live region
     * 	so that screen readers can announce the message
     */
    renderMessageWrapper() {
        return (h("div", { role: Role.ALERT, "aria-atomic": 'true' }, this.renderMessage()));
    }
    /**
     * Creates a data test selector for the component.
     * @param suffix - The suffix to append to the data test selector.
     * @returns {string} The data test selector string.
     */
    createDataTestSelector(suffix = this.dataTestSuffix) {
        return createSelector(this.host.tagName, suffix);
    }
    /**
     * @returns {JSX.IntrinsicElements['bxf-date-input']} - Props for bxf-date-input component
     */
    get dateInputProps() {
        return {
            isStandaloneComponent: false,
            separator: this.separator,
            eventDateSeparator: this.eventDateSeparator,
            blurredElement: 'host',
            isDisabled: this.isDisabled,
            isReadOnly: this.isReadOnly,
            keepMouseFocus: this.keepMouseFocus,
            validationType: this.validationType,
            inputDateFormat: this.dateFormat,
            displayDateFormat: this.displayDateFormat,
            isDisplayDateAllCaps: this.isDisplayDateAllCaps,
            keepRelativeDate: this.keepRelativeDate,
            size: this.size,
            eventData: this.eventData,
            isRequired: this.isRequired,
            relativeDateValue: this.relativeDateValue,
            isRelativeDate: this.isRelativeDate,
            errorMessage: null,
            showInputGuide: this.showInputGuide,
            assistiveText: this.label ?? this.assistiveText,
            ariaDescriptionAttr: this.instructionalText,
            ariaInvalidAttr: !this.isValid,
            inputValue: this.value,
            dataTestSuffix: this.dataTestSuffix,
            onKeyUp: this.handleInputValidity,
            onKeyDown: this.keyDownHandler,
            onBlurChanged: this.handleFocusChange,
            onFocusChanged: this.handleFocusChange,
            isTracking: this.isTracking,
            trackingData: this.trackingData,
            namespaceI18n: this.namespaceI18n,
            i18nKeys: this.dateInputI18nKeys,
        };
    }
    /**
     * @returns {JSX.IntrinsicElements['bxf-calendar']} - Props for bxf-calendar component
     */
    get calendarProps() {
        return {
            isOverlay: true,
            isRange: false,
            maxDaysSelectable: 1,
            separator: this.separator,
            eventDateSeparator: this.eventDateSeparator,
            dateFormat: this.dateFormat,
            displayDateFormat: this.displayDateFormat,
            initActiveMonth: this.initActiveMonth,
            initActiveYear: this.initActiveYear,
            hasSeparatorSettings: this.hasSeparatorSettings,
            hasDateFormatSettings: this.hasDateFormatSettings,
            initWithToday: this.initWithToday,
            values: this.dateObj,
            settingsSelectData: this.settingsSelectData,
            todayButtonMenuData: this.todayButtonMenuData,
            footerShortcutData: this.footerShortcutData,
            showTodayButtonAsShortcut: this.showTodayButtonAsShortcut,
            disabledDates: this.disabledDates,
            disableWeekends: this.disableWeekends,
            hasTodayInFooter: this.hasTodayInFooter,
            hideDatesOutsideActiveMonth: this.hideDatesOutsideActiveMonth,
            keepTodayEnabled: this.keepTodayEnabled,
            holidays: this.holidays,
            customDateMarkerA: this.customDateMarkerA,
            customDateMarkerB: this.customDateMarkerB,
            showMarkerPopovers: this.showMarkerPopovers,
            calendarNote: this.calendarNote,
            footerLabel: this.footerLabel,
            hasCalendarFooter: this.isFooterVisible,
            hasFooterSettings: this.hasFooterSettings,
            hasFooterLabel: this.hasFooterLabel,
            hasMarkerKey: this.hasMarkerKey,
            isCalendarVisible: this.isOpen,
            isHeaderDynamic: true,
            isDatesUnselectable: false,
            isTodayHighlighted: this.isTodayHighlighted,
            minDateSelectable: this.minDateSelectable,
            maxDateSelectable: this.maxDateSelectable,
            isTracking: this.isTracking,
            trackingData: this.trackingData,
            isMonthSelectDisabled: this.isReadOnly,
            isYearSelectDisabled: this.isReadOnly,
            isDisabled: this.isDisabled,
            filterMonths: this.filterMonths,
            defaultPopoverHeader: this.defaultPopoverHeader,
            hideInactiveDateDetails: this.hideInactiveDateDetails,
            dataTestSuffix: this.dataTestSuffix,
            i18nKeys: this.calendarI18nKeys,
            eventData: this.eventData,
            calendarSettingsI18nKeys: this.calendarSettingsI18nKeys,
            isFooterDisabled: this.isFooterDisabled,
            namespaceI18n: this.namespaceI18n,
        };
    }
    /**
     * Function that returns the label for the date picker
     * @returns {JSX.Element} The label div element for the date picker
     **/
    renderLabel() {
        /* istanbul ignore else */
        if (!this.label)
            return null;
        const asterisk = this.isRequired ? (h("div", { class: DATE_INPUT_REQUIRED, "aria-hidden": 'true' }, "*")) : null;
        return (h("div", { key: this.labelId, class: this.labelCss, "data-test": this.createDataTestSelector(LABEL_CONTAINER) }, this.label, asterisk));
    }
    /**
     * Function that return the instructional text for the date picker
     * @returns {JSX.Element} The instructional text div element for the date picker
     **/
    renderInstructionalText() {
        const { INSTRUCTIONAL_TEXT } = BxfDateInputConstants.STRING;
        return (h("div", { style: { paddingLeft: this.leftLabelOffset }, ...(this.instructionalText && { class: INSTRUCTIONAL_TEXT }) }, h("span", { id: this.descriptionId }, this.instructionalText)));
    }
    /**
     * Renders the input element for the date picker component.
     * @returns {JSX.Element} The JSX element representing the date input element.
     */
    renderPicker() {
        return (h("div", { key: this.datePickerId, ref: this.datePickerRefHandler, class: this.containerClasses, "data-test": this.createDataTestSelector(DATE_PICKER_CONTAINER), role: Role.GROUP, onMouseEnter: () => {
                this.inputClicked = true;
            }, onMouseLeave: () => {
                this.inputClicked = false;
            } }, h("bxf-date-input", { ref: this.dateInputRefHandler, ...this.dateInputProps }), this.renderCalendarButton(), this.renderCalendar()));
    }
    /**
     * Function that handles when calendar button is clicked
     * @param e - MouseEvent
     */
    calendarButtonClickHandler(e) {
        this.suffixChanged.emit({ eventData: this.eventData, srcEvent: e });
        if (!this.isOpen)
            return;
        this.isFocused = false;
        this.inputClicked = false;
        this.setIsOpen(false);
    }
    /**
     * Function that renders calendar button that allows the user to open/close the calendar overlay
     * @returns JSX.Element - The calendar bxf-button component
     */
    renderCalendarButton() {
        const ariaConfig = {
            [AriaAttr.HASPOPUP]: HasPopupValue.DIALOG,
            [AriaAttr.EXPANDED]: String(this.isOpen),
        };
        const type = this.isFocused || this.isOpen
            ? BxfButtonTypeEnum.TERTIARY
            : BxfButtonTypeEnum.TERTIARY_SUBTLE;
        return (h("div", { key: this.calendarButtonId, class: CALENDAR_BUTTON_CONTAINER$1 }, h("bxf-button", { ref: (el) => this.iconRefHandler(el), class: CALENDAR_BUTTON$1, assistiveText: CALENDAR_BUTTON_LABEL, onClick: this.calendarButtonClickHandler, ariaConfig: ariaConfig, type: type, icon: BxfIconTypeEnum.calendar, isDisabled: this.isDisabled || this.isReadOnly, "data-test": this.createDataTestSelector(SUFFIX_BUTTON), dataTestSuffix: createSelector(SUFFIX_BUTTON, this.dataTestSuffix, true) })));
    }
    /**
     * Function that handles when a date is selected from the calendar.
     * - Sets the value of the input to the selected date.
     * - Closes the calendar if the closeCalendarOnBlur prop is true.
     * @param event - CustomEvent<BxfCalendarDateSelectedDetailInterface>
     */
    handleCalendarValueChange(event) {
        event.stopPropagation();
        const value = this.momentToString(moment(event.detail.value, BxfDatePickerDateFormatEnum.DD_MM_YYYY));
        this.emitValueChanged(value);
        !this.closeCalendarOnBlur && this.setIsOpen(false);
        this.dateSelected.emit({
            ...event.detail,
            value: this.value.replace(getSeparatorRegex(this.separator), this.eventDateSeparator),
        });
    }
    /**
     * Function that renders the calendar
     * @returns {JSX.Element} The calendar component for the overlay and the calendar button
     */
    renderCalendar() {
        const focusSrcHandlers = this.keepMouseFocus
            ? {}
            : {
                onKeyDown: this.keyDownHandler,
            };
        return (h("bxf-calendar", { ref: (el) => this.calendarRefHandler(el), key: this.calendarId, ...focusSrcHandlers, ...this.calendarProps, onFooterClicked: this.handleFooterButtonOnClick, onDateSelected: this.handleCalendarValueChange, onCalendarValueChanged: (e) => {
                e.stopPropagation();
                const value = this.toInitialDateFormat(e.detail.value);
                this.calendarValueChanged.emit({ ...e.detail, value });
            }, onDateChanged: (e) => {
                e.stopPropagation();
                const date = this.toInitialDateFormat(e.detail.date);
                this.dateChanged.emit({ ...e.detail, date });
            }, onMonthChanged: (e) => {
                e.stopPropagation();
                this.monthChanged.emit(e.detail);
            }, onYearChanged: (e) => {
                e.stopPropagation();
                this.yearChanged.emit(e.detail);
            }, onCalendarSelected: (e) => {
                e.stopPropagation();
                this.calendarSelected.emit(e.detail);
            }, onDateFormatSelected: (e) => {
                e.stopPropagation();
                const { dateFormat } = e.detail;
                this.dateInputRef?.setUserDateFormatValue(dateFormat);
                this.dateFormat = dateFormat;
                this.displayDateFormat = dateFormat;
                this.dateFormatSelected.emit(e.detail);
            }, onSeparatorSelected: (e) => {
                e.stopPropagation();
                this.separator = e.detail.separator;
                this.separatorSelected.emit(e.detail);
            }, onShortcutClicked: (e) => {
                e.stopPropagation();
                this.shortcutClicked.emit(e.detail);
            }, onTodayButtonMenuItemClicked: (e) => {
                const { isOpen, value } = e.detail;
                e.stopPropagation();
                this.calendarTodayButtonMenuItemClicked = isOpen;
                value && this.todayButtonMenuItemClicked.emit(e.detail);
            }, parentOverlayContainerSelector: this.parentOverlayContainerSelector }));
    }
    render() {
        return (h("div", { key: 'eacbe89722f38ff553bb35bf8eea5b5c6c9f4a3f', "aria-label": this.label || this.assistiveText, "data-test": this.createDataTestSelector() }, !this.isLeftLabel && this.renderLabel(), h("div", { key: 'f5c22a12eab63eac061d50103bbe5694bf39d536', class: DATE_PICKER_CONTAINER }, this.renderInstructionalText(), h("div", { key: 'c1e6165fff45fafdbe2a5ed8a1d7540b039d42ef', class: LEFT_LABEL_CONTAINER$1 }, this.isLeftLabel && this.renderLabel(), this.renderPicker()), this.renderMessageWrapper())));
    }
    static get watchers() { return {
        "dateFormat": ["dateFormatChangeHandler"],
        "disabledDates": ["disabledDatesChangeHandler"],
        "displayDateFormat": ["displayDateFormatChangeHandler"],
        "eventDateSeparator": ["eventDateSeparatorChangeHandler"],
        "isOpen": ["calendarOpenHandler"],
        "maxDate": ["maxDateHandler"],
        "maxYear": ["maxDateHandler"],
        "minDate": ["minDateHandler"],
        "minYear": ["minDateHandler"],
        "separator": ["separatorChangeHandler"],
        "value": ["valueChangedHandler"]
    }; }
};
BxfDatePicker.style = BxfDatePickerStyle0;

const bxfDateRangePickerCss = "button.sc-bxf-date-range-picker:hover,a.sc-bxf-date-range-picker:hover,input[type=radio].sc-bxf-date-range-picker:hover,input[type=checkbox].sc-bxf-date-range-picker:hover,input[type=radio].sc-bxf-date-range-picker:checked:hover,input[type=checkbox].sc-bxf-date-range-picker:checked:hover,svg.sc-bxf-date-range-picker:hover{cursor:pointer}svg[disabled].sc-bxf-date-range-picker:hover,button[disabled].sc-bxf-date-range-picker:hover,label[disabled].sc-bxf-date-range-picker:hover,input[type=checkbox].sc-bxf-date-range-picker:disabled:hover,input[type=radio].sc-bxf-date-range-picker:disabled:hover,input[type=checkbox].sc-bxf-date-range-picker:checked:disabled:hover,input[type=radio].sc-bxf-date-range-picker:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-date-range-picker{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-date-range-picker__container.sc-bxf-date-range-picker,.bxf-date-range-picker__container--success.sc-bxf-date-range-picker,.bxf-date-range-picker__container--warning.sc-bxf-date-range-picker,.bxf-date-range-picker__container--invalid.sc-bxf-date-range-picker,.bxf-date-range-picker__container--disabled.sc-bxf-date-range-picker,.bxf-date-range-picker__container--focused.sc-bxf-date-range-picker{display:flex;padding-right:0.75rem;background-color:var(--date-picker__background-color);border:0.0625rem solid var(--form-element__border-color);border-radius:0.125rem;display:inline-flex;padding-right:0.75rem}.bxf-date-range-picker__container--focused.sc-bxf-date-range-picker{background-color:var(--focus-highlight_background-color) !important;border-bottom:0.0625rem solid var(--input__border-bottom-color_focus)}.bxf-date-range-picker__container--disabled.sc-bxf-date-range-picker{background-color:var(--input-box__background-color--disabled) !important}.bxf-date-range-picker__container--invalid.sc-bxf-date-range-picker{border:0.0625rem solid var(--form-element__border-color--error);background-color:var(--form-element__background-color--error) !important}.bxf-date-range-picker__container--warning.sc-bxf-date-range-picker{border:0.0625rem solid var(--form-element__border-color--warning);background-color:var(--form-element__background-color--warning) !important}.bxf-date-range-picker__container--success.sc-bxf-date-range-picker{border:0.0625rem solid var(--form-element__border-color--success);background-color:var(--form-element__background-color--success) !important}.bxf-date-range-picker__input-container.sc-bxf-date-range-picker,.bxf-date-range-picker__input-container-end.sc-bxf-date-range-picker,.bxf-date-range-picker__input-container-start.sc-bxf-date-range-picker{display:flex}.bxf-date-range-picker__mid-label-container.sc-bxf-date-range-picker,.bxf-date-range-picker__mid-label-container--disabled.sc-bxf-date-range-picker{display:grid;color:var(--primary-text__color);margin:auto 0.5rem auto 0.5rem;align-content:center}.bxf-date-range-picker__mid-label-container--disabled.sc-bxf-date-range-picker{color:var(--disabled-text__color)}.bxf-date-range-picker__mid-label-container.sc-bxf-date-range-picker:hover,.bxf-date-range-picker__mid-label-container--disabled.sc-bxf-date-range-picker:hover{cursor:default}.bxf-date-range-picker__calendar_button_container.sc-bxf-date-range-picker{margin:auto -0.5rem}.bxf-date-range-picker__calendar-button.sc-bxf-date-range-picker{display:flex}.bxf-date-range-picker__calendar-button-container.sc-bxf-date-range-picker{margin:auto -0.5rem}.bxf-date-range-picker__instructional-text.sc-bxf-date-range-picker{padding-bottom:0.5rem;color:var(--secondary-text__color)}.bxf-date-range-picker__instructional-text--is-compact.sc-bxf-date-range-picker{padding-bottom:0.25rem}.bxf-date-range-picker__left-label-container.sc-bxf-date-range-picker{display:flex;flex-direction:row}.bxf-date-range-picker__label.sc-bxf-date-range-picker,.bxf-date-range-picker__label--disabled.sc-bxf-date-range-picker,.bxf-date-range-picker__label--compact.sc-bxf-date-range-picker{font-size:0.8125rem;max-width:fit-content;min-width:fit-content;width:fit-content;color:var(--primary-text__color);flex:1 1 0%;line-height:1rem;padding-bottom:0.5rem;white-space:nowrap}.bxf-date-range-picker__label--compact.sc-bxf-date-range-picker{padding-bottom:0.25rem}.bxf-date-range-picker__label--disabled.sc-bxf-date-range-picker{color:var(--disabled-text__color)}.bxf-date-range-picker__label-left.sc-bxf-date-range-picker,.bxf-date-range-picker__label-left--disabled.sc-bxf-date-range-picker,.bxf-date-range-picker__label-left--compact.sc-bxf-date-range-picker{display:inline-flex;align-items:center;padding-right:0.75rem}.bxf-date-range-picker__label-left--compact.sc-bxf-date-range-picker{padding-right:0.5rem}.bxf-date-range-picker__label-left--disabled.sc-bxf-date-range-picker{color:var(--disabled-text__color)}.bxf-date-range-picker__message.sc-bxf-date-range-picker,.bxf-date-range-picker__message--success.sc-bxf-date-range-picker,.bxf-date-range-picker__message--warning.sc-bxf-date-range-picker,.bxf-date-range-picker__message--error.sc-bxf-date-range-picker{display:flex;font-size:0.8125rem;line-height:1.2307692308;padding-top:0.25rem}.bxf-date-range-picker__message--error.sc-bxf-date-range-picker{color:var(--text__color--error)}.bxf-date-range-picker__message--success.sc-bxf-date-range-picker{color:var(--text__color--success)}.bxf-date-range-picker__label--required.sc-bxf-date-range-picker{padding-left:0.25rem;color:var(--text__color--error);font-size:1rem;line-height:1.1875;padding-bottom:0.25rem;float:right}";
const BxfDateRangePickerStyle0 = bxfDateRangePickerCss;

const { RANGE_PICKER_CONTAINER, FOCUSED_CONTAINER, DISABLED_CONTAINER, INVALID_CONTAINER, INSTRUCTIONAL_TEXT, INSTRUCTIONAL_TEXT_COMPACT, WARNING_CONTAINER, SUCCESS_CONTAINER, START_INPUT_CONTAINER, END_INPUT_CONTAINER, MID_LABEL, MID_LABEL_CONTAINER, MID_LABEL_CONTAINER_DISABLED, CALENDAR_BUTTON, CALENDAR_BUTTON_CONTAINER, CALENDAR_BUTTON_ASSISTIVE_TEXT, LABEL, REQUIRED_LABEL, DISABLED_LABEL, LEFT_LABEL_CONTAINER, LABEL_COMPACT, LEFT_LABEL, LEFT_LABEL_COMPACT, ERROR_MESSAGE, WARNING_MESSAGE, SUCCESS_MESSAGE, DEFAULT_US, MMMM, ASSISTIVE_TEXT_GROUP, ASSISTIVE_TEXT_END, ASSISTIVE_TEXT_START, ASSISTIVE_TEXT_START_LABEL, ASSISTIVE_TEXT_END_LABEL, INPUT, INSTRUCTIONAL_TEXT_DATA_TEST, } = BxfDateRangePickerConstants.STRING;
const BxfDateRangePicker = class {
    get host() { return getElement(this); }
    dateRangePickerRef;
    calendarRef;
    calendarButtonRef;
    startDateRef;
    endDateRef;
    startTextInputElement;
    endTextInputElement;
    overlay;
    defaultValidator = defaultDateRangeValidator;
    i18n;
    descriptionId = uuidv4();
    labelId = uuidv4();
    calendarButtonId = uuidv4();
    calendarId = uuidv4();
    rangePickerId = uuidv4();
    startInputId = uuidv4();
    endInputId = uuidv4();
    initDateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
    startAssistiveTextFallback = ASSISTIVE_TEXT_START_LABEL;
    endAssistiveTextFallback = ASSISTIVE_TEXT_END_LABEL;
    displayDateFormatChangeHandler(newValue) {
        this.displayDateFormat = mapDateFormat(newValue);
    }
    endValueChangedHandler(newValue) {
        this.setCalendarValues(this.startValue, newValue);
    }
    eventDateSeparatorChangeHandler(newValue) {
        if (isEmpty(newValue))
            this.eventDateSeparator = this.separator;
    }
    inputDateFormatChangeHandler(newValue, oldValue) {
        this.inputDateFormat = mapDateFormat(newValue);
        this.startValue = updateFormatDate(this.startValue, oldValue, newValue, this.separator);
        this.endValue = updateFormatDate(this.endValue, oldValue, newValue, this.separator);
    }
    calendarOpenHandler(newValue) {
        /* istanbul ignore else */
        if (!newValue) {
            this.overlay?.close(this.isMouseFocus);
            this.overlay = null;
            setTimeout(() => {
                this.isOpen = false;
                this.setValidState();
            }, 0);
            this.calendarClosed.emit();
        }
    }
    maxDateHandler() {
        this.maxDateSelectable = dateBoundHandler(this.maxDate, this.maxYear, this.separator, this.inputDateFormat, false);
    }
    minDateHandler() {
        this.minDateSelectable = dateBoundHandler(this.minDate, this.minYear, this.separator, this.inputDateFormat, true);
    }
    separatorChangeHandler(newValue, oldValue) {
        if (isEmpty(this.eventDateSeparator))
            this.eventDateSeparator = this.separator;
        this.startValue = updateSeparator(this.startValue, oldValue, newValue);
        this.endValue = updateSeparator(this.endValue, oldValue, newValue);
    }
    startValueChangedHandler(newValue) {
        this.setCalendarValues(newValue, this.endValue);
    }
    /**
     * This event is emitted on change of value
     */
    calendarValueChanged;
    /**
     * This event is emitted when a calendar shortcut is clicked
     */
    calendarShortcutClicked;
    /**
     * The event is emitted when the calendar icon is selected.
     */
    calendarButtonClicked;
    /**
     * This event is emitted when calendar overlay is closed
     */
    calendarClosed;
    /**
     * This event is emitted when end calendar's footer is clicked
     */
    calendarFooterClicked;
    /**
     * This event is emitted when calendar overlay is opened
     */
    calendarOpened;
    /**
     * This event is emitted when an item in the calendar reset button inline menu is selected.
     */
    calendarResetButtonMenuItemClicked;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted when date (day) changes
     */
    dateChanged;
    /**
     * This event is emitted when date (day) is selected
     */
    dateSelected;
    /**
     * This event is emitted on change of end value
     */
    endValueChanged;
    /**
     * This event is emitted on focus change of text input
     */
    focusChanged;
    /**
     * This event is emitted on change of value for form validation
     */
    formValueChanged;
    /**
     * The event is emitted when the user's input a possible or full date.
     */
    invalidInputDate;
    /**
     * This event is emitted when month changes
     */
    monthChanged;
    /**
     * This event is emitted on change of start value
     */
    startValueChanged;
    /**
     * This event is emitted on change of values
     */
    valueChanged;
    /**
     * This event is emitted when year changes
     */
    yearChanged;
    /**
     * Public method that would clear current value and reset it to mask
     */
    async clearValue() {
        this.startValue = undefined;
        this.endValue = undefined;
        this.values = [];
        this.emitFormValueChangedOnClear && this.formValueChanged.emit();
    }
    /**
     * Public method that closes the calendar overlay
     */
    async close() {
        this.isOpen = false;
    }
    /**
     * This method allows for focusing on the component's end text input element
     */
    async focusEndInput() {
        this.isStartFocused = false;
        this.isEndFocused = true;
        await this.endDateRef?.focusInput(this.focusSource);
    }
    /**
     * This method allows for focusing on the component's start text input element
     */
    async focusStartInput() {
        this.isStartFocused = true;
        this.isEndFocused = false;
        await this.startDateRef?.focusInput(this.focusSource);
    }
    /**
     * Public method that opens the calendar overlay
     */
    async open() {
        this.isOpen = true;
    }
    /**
     * Used to set value for forms
     * @param newValue - The new value to be set to start and end input
     */
    async setValue(newValue) {
        this._setValue(newValue);
    }
    /**
     * Used to toggle disable for forms
     * @param action - boolean to determine if the component should be disabled
     */
    async toggleDisable(action) {
        this.isDisabled = action;
    }
    /**
     * Public method to initialize validators on date-range-picker value
     * @param value - The value to be validated
     * @returns {boolean} - True if the value passes form validation
     */
    async validate(value) {
        /* istanbul ignore else */
        if (this.validator) {
            this.defaultValidator = getValidator(this.validator);
            const isValid = this.defaultValidator.validate(value);
            this.errorMessage = this.defaultValidator.errorMessage;
            return isValid;
        }
        const { startDateMoment, endDateMoment } = value;
        return this.defaultValidator.validate(startDateMoment, endDateMoment);
    }
    /**
     * Function checks if value is invalid when used for required validation in forms
     * @param newValue - The new value to be validated
     * @returns {boolean} - True if the value is not provided and required validator should return error
     */
    async validateForRequired(newValue) {
        // should return true if value is not provided and required validator should return error
        return Promise.resolve(!(isEmpty(newValue.startValue) || isEmpty(newValue.endValue)));
    }
    /**
     * This listener is called when the calendar is connected
     */
    openCalendar() {
        this.overlay?.openOverlayWithPosition();
        this.calendarOpened.emit();
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.calendarValueChanged = createEvent(this, "calendarValueChanged", 7);
        this.calendarShortcutClicked = createEvent(this, "calendarShortcutClicked", 7);
        this.calendarButtonClicked = createEvent(this, "calendarButtonClicked", 7);
        this.calendarClosed = createEvent(this, "calendarClosed", 7);
        this.calendarFooterClicked = createEvent(this, "calendarFooterClicked", 7);
        this.calendarOpened = createEvent(this, "calendarOpened", 7);
        this.calendarResetButtonMenuItemClicked = createEvent(this, "calendarResetButtonMenuItemClicked", 7);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.dateChanged = createEvent(this, "dateChanged", 7);
        this.dateSelected = createEvent(this, "dateSelected", 7);
        this.endValueChanged = createEvent(this, "endValueChanged", 7);
        this.focusChanged = createEvent(this, "focusChanged", 7);
        this.formValueChanged = createEvent(this, "formValueChanged", 7);
        this.invalidInputDate = createEvent(this, "invalidInputDate", 7);
        this.monthChanged = createEvent(this, "monthChanged", 7);
        this.startValueChanged = createEvent(this, "startValueChanged", 7);
        this.valueChanged = createEvent(this, "valueChanged", 7);
        this.yearChanged = createEvent(this, "yearChanged", 7);
        this.hasKeyboardFocus = false;
        this.isStartFocused = false;
        this.isEndFocused = false;
        this.inputClicked = false;
        this.values = [];
        this.minDateSelectable = undefined;
        this.maxDateSelectable = undefined;
        this.focusSource = undefined;
        this.assistiveText = '';
        this.calendarI18nKeys = undefined;
        this.calendarSettingsI18nKeys = undefined;
        this.calendarNote = undefined;
        this.closeCalendarOnBlur = true;
        this.closeCalendarOnScroll = true;
        this.customDateMarkerA = {};
        this.customDateMarkerB = {};
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.dateInputI18nKeys = undefined;
        this.defaultPopoverHeader = undefined;
        this.displayDateFormat = BxfDatePickerDateFormatEnum.DD_MMM_YYYY;
        this.disabledDates = [];
        this.emitFormValueChangedOnClear = false;
        this.endDateRelativeValue = 'T-1';
        this.endValue = undefined;
        this.errorMessage = undefined;
        this.eventData = {};
        this.eventDateSeparator = undefined;
        this.filterMonths = false;
        this.footerLabel = DEFAULT_US;
        this.footerShortcutData = [];
        this.instructionalText = undefined;
        this.hasDateFormatSettings = true;
        this.hasCalendarFooter = true;
        this.hideDatesOutsideActiveMonth = false;
        this.hasFooterSettings = true;
        this.hideInactiveDateDetails = false;
        this.hasSeparatorSettings = true;
        this.holidays = {};
        this.initActiveMonth = undefined;
        this.initActiveYear = undefined;
        this.initWithToday = false;
        this.inputDateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
        this.isCompact = BxfDefaultState.isCompact;
        this.isDisabled = false;
        this.isReadOnly = false;
        this.isDisplayDateAllCaps = false;
        this.isFooterDisabled = false;
        this.isLeftLabel = false;
        this.isOpen = false;
        this.isRelativeDate = false;
        this.isRelativeEndDate = false;
        this.isRelativeStartDate = false;
        this.isRequired = false;
        this.isSuccess = false;
        this.isTodayHighlighted = true;
        this.isTracking = true;
        this.isValid = true;
        this.i18nKeys = undefined;
        this.keepMouseFocus = false;
        this.keepRelativeDate = false;
        this.keepRelativeEndDate = false;
        this.keepRelativeStartDate = false;
        this.label = undefined;
        this.maxDate = undefined;
        this.maxYear = undefined;
        this.minDate = undefined;
        this.minYear = undefined;
        this.namespaceI18n = undefined;
        this.overridePlacement = BxfDynamicPositionEnum.BOTTOM_LEFT;
        this.separator = BxfDatePickerSeparatorsEnum.DASH;
        this.settingsSelectData = [];
        this.showInputGuide = true;
        this.showMarkerPopovers = false;
        this.size = 'regular';
        this.skipValidation = false;
        this.sourceElementCustomClass = [];
        this.startDateRelativeValue = 'T-1';
        this.startValue = undefined;
        this.successMessage = null;
        this.targetElementCustomClass = [];
        this.trackingData = undefined;
        this.trigger = BxfOverlayTriggerEnum.PRESSED;
        this.validationType = BxfFormValidationType.ERROR;
        this.validator = undefined;
        this.setIsOpen = this.setIsOpen.bind(this);
        this.shouldOpen = this.shouldOpen.bind(this);
        this.shouldClose = this.shouldClose.bind(this);
        this.dateRangePickerRefHandler =
            this.dateRangePickerRefHandler.bind(this);
        this.calendarButtonRefHandler =
            this.calendarButtonRefHandler.bind(this);
        this.handleCalendarValueChange =
            this.handleCalendarValueChange.bind(this);
        this.calendarRefHandler = this.calendarRefHandler.bind(this);
        this.handleEndInputValidity = this.handleEndInputValidity.bind(this);
        this.handleStartFocusChange = this.handleStartFocusChange.bind(this);
        this.handleMiddleFocusChange = this.handleMiddleFocusChange.bind(this);
        this.handleEndFocusChange = this.handleEndFocusChange.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.mouseDownHandler = this.mouseDownHandler.bind(this);
        this.touchStartHandler = this.touchStartHandler.bind(this);
        this.handleStartInputValidity =
            this.handleStartInputValidity.bind(this);
        this.handleFooterButtonClick = this.handleFooterButtonClick.bind(this);
        this.calendarButtonClickHandler =
            this.calendarButtonClickHandler.bind(this);
    }
    componentWillLoad() {
        this.eventDateSeparator = this.eventDateSeparator || this.separator;
        this.inputDateFormat = mapDateFormat(this.inputDateFormat);
        this.displayDateFormat = mapDateFormat(this.displayDateFormat);
        // The initial date format is set to the input date format.
        // Can be used for event to maintain the initial date format.
        this.initDateFormat = this.inputDateFormat;
        this.startValue = this.startValue || '';
        this.endValue = this.endValue || '';
        /* istanbul ignore else */
        if (!this.keepMouseFocus)
            this.focusSource = FocusSource.Keyboard;
        this.setCalendarValues(this.startValue, this.endValue);
        this.minDateHandler();
        this.maxDateHandler();
        /* istanbul ignore else */
        if (this.isRelativeDate) {
            this.isRelativeStartDate = this.isRelativeDate;
            this.isRelativeEndDate = this.isRelativeDate;
        }
        /* istanbul ignore else */
        if (this.keepRelativeDate) {
            this.keepRelativeStartDate = this.keepRelativeDate;
            this.keepRelativeEndDate = this.keepRelativeDate;
        }
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
    }
    componentDidLoad() {
        this.initializeTextInputElements();
        this.setValidState();
    }
    disconnectedCallback() {
        this.isOpen = false;
        this.i18n?.destroyTranslations();
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    /**
     * Binds new values to the range picker and validates those new values
     * @param startValue - the start date of the range to be validated
     * @param endValue - the start date of the range to be validated
     */
    async setValidState(start = this.startValue, end = this.endValue) {
        if (this.skipValidation)
            return;
        const startValue = start?.replace(getSeparatorRegex(this.eventDateSeparator), this.separator);
        const endValue = end?.replace(getSeparatorRegex(this.eventDateSeparator), this.separator);
        if (this.isRelativeStartDate || this.isRelativeEndDate)
            return;
        const startDateMoment = strToMoment(startValue, this.separator, this.inputDateFormat);
        const endDateMoment = strToMoment(endValue, this.separator, this.inputDateFormat);
        const isDisabled = await this.calendarRef?.isDisabledDate();
        const passesFormValidation = await this.validate({
            startValue,
            endValue,
            startDateMoment,
            endDateMoment,
        });
        this.isValid =
            (!this.isRequired &&
                isEmpty(this.startTextInputElement?.value) &&
                isEmpty(this.endTextInputElement?.value)) ||
                (!isDisabled && passesFormValidation);
    }
    _setValue(newValue) {
        const { startValue: start, startDateMoment, endValue: end, endDateMoment, } = newValue || {};
        const startValue = start
            ? (startDateMoment?.format(this.inputDateFormat.replace(SPACE_REGEX, this.separator)) ??
                start.replace(getSeparatorRegex(this.eventDateSeparator), this.separator))
            : '';
        const endValue = end
            ? (endDateMoment?.format(this.inputDateFormat.replace(SPACE_REGEX, this.separator)) ??
                end.replace(getSeparatorRegex(this.eventDateSeparator), this.separator))
            : '';
        if (isNil(startValue) || isNil(endValue))
            return;
        const isDiffStartDate = startValue !== this.startValue;
        const isDiffEndDate = endValue !== this.endValue;
        isDiffStartDate &&
            isValidDateFormat(start, this.separator, this.inputDateFormat) &&
            this.setStartInput(startValue);
        isDiffEndDate &&
            isValidDateFormat(end, this.separator, this.inputDateFormat) &&
            this.setEndInput(endValue);
        (isDiffStartDate || isDiffEndDate) &&
            this.setCalendarValues(startValue, endValue);
    }
    /**
     * Emits the value changed event for start and end value and relativeDateValue props.
     * @param newStartValue - The new start value
     * @param newEndValue - The new end value
     */
    emitValueChanged(newStartValue, newEndValue) {
        const valueChangedData = this.getValueChangedData(newStartValue?.replace(getSeparatorRegex(this.separator), this.eventDateSeparator), newEndValue?.replace(getSeparatorRegex(this.separator), this.eventDateSeparator));
        const { srcEvent, ...formValueChangeData } = valueChangedData;
        const hasNewStartValue = this.shouldEmit(newStartValue, this.startValue);
        const hasNewEndValue = this.shouldEmit(newEndValue, this.endValue);
        /* istanbul ignore else */
        if (hasNewStartValue || hasNewEndValue) {
            const { startValue, startDisplayValue, startDateObject, startDateMoment, endValue, endDisplayValue, endDateObject, endDateMoment, } = valueChangedData;
            hasNewStartValue &&
                this.startValueChanged.emit({
                    displayValue: startDisplayValue,
                    value: startValue,
                    dateMoment: startDateMoment,
                    dateObject: startDateObject,
                    eventData: this.eventData,
                    srcEvent,
                });
            hasNewEndValue &&
                this.endValueChanged.emit({
                    displayValue: endDisplayValue,
                    value: endValue,
                    dateMoment: endDateMoment,
                    dateObject: endDateObject,
                    eventData: this.eventData,
                    srcEvent,
                });
            this.valueChanged.emit(valueChangedData);
            this.formValueChanged.emit({
                value: formValueChangeData,
                srcEvent,
            });
            this._setValue({
                ...formValueChangeData,
                startValue: newStartValue,
                endValue: newEndValue,
            });
        }
    }
    /**
     * Determines if the value changed events of the date range picker should be emitted.
     * @param newValue - The new date value
     * @param oldValue - The old date value
     * @returns {boolean} - True if the value changed events should be emitted, false otherwise
     */
    shouldEmit(newValue, oldValue) {
        return (newValue || oldValue) && newValue !== oldValue;
    }
    /**
     * Gets detail data objects for value change events
     * @param startValue - The new start value
     * @param endValue - The new end value
     * @returns {BxfDateRangePickerValueChangedDetailInterface} The value changed detail object
     */
    getValueChangedData(startDate, endDate) {
        let startValue = startDate;
        let endValue = endDate;
        const startDateMoment = null;
        const endDateMoment = null;
        if (!isRelativeValue(startDate)) {
            const startDateMoment = strToMoment(startDate, this.eventDateSeparator, this.inputDateFormat);
            startValue = startDateMoment.isValid()
                ? startDateMoment.format(this.initDateFormat.replace(SPACE_REGEX, this.eventDateSeparator))
                : startDate;
        }
        if (!isRelativeValue(endDate)) {
            const endDateMoment = strToMoment(endDate, this.eventDateSeparator, this.inputDateFormat);
            endValue = endDateMoment.isValid()
                ? endDateMoment.format(this.initDateFormat.replace(SPACE_REGEX, this.eventDateSeparator))
                : endDate;
        }
        return {
            startValue,
            startDisplayValue: this.getDisplayValue(startValue),
            startDateObject: startDateMoment?.toDate() || null,
            startDateMoment,
            endValue,
            endDisplayValue: this.getDisplayValue(endValue),
            endDateObject: endDateMoment?.toDate() || null,
            endDateMoment,
            eventData: this.eventData,
            srcEvent: null,
        };
    }
    /**
     * Updates the state of the calendar overlay
     * @param value - The new value of `isOpen`.
     */
    setIsOpen(value) {
        this.isOpen = value;
    }
    /**
     * Determines whether the date range picker should be open.
     * @returns {boolean} `true` if the date picker should be open, `false` otherwise.
     */
    shouldOpen() {
        return !(this.isDisabled && this.isReadOnly);
    }
    /**
     * Determines whether the date range picker should be closed.
     * The date picker should be closed if neither the input nor the calendar today button were clicked.
     * @returns {boolean} True if the date picker should be closed, false otherwise.
     */
    shouldClose() {
        return (this.isStartFocused && this.isEndFocused) || !this.inputClicked;
    }
    /**
     * Sets the calendar values the match the start and end text values.
     * Will not show anything on calendar if:
     * - there is end date with no start date
     * - the end date comes before the start date
     * @param startValue - The start text value.
     * @param endValue - The end text value.
     */
    setCalendarValues(startValue = this.startValue, endValue = this.endValue) {
        const isEndDateBeforeStartDate = strToMoment(endValue, this.separator, this.inputDateFormat)?.isBefore(moment(this.startValue, this.inputDateFormat.replace(SPACE_REGEX, this.separator), true));
        if (isEmpty(startValue) || isEndDateBeforeStartDate) {
            this.values = [];
        }
        else {
            const startDateValue = strToDateObj(startValue, this.separator, this.inputDateFormat).pop();
            const endDateValue = strToDateObj(endValue, this.separator, this.inputDateFormat).pop();
            this.values = [...compact([startDateValue, endDateValue])];
        }
    }
    /**
     * Function that renders the label classnames for the component
     * @returns {string} The label classnames
     */
    get labelClass() {
        let className = this.isCompact ? `${LABEL} ${LABEL_COMPACT}` : LABEL;
        /* istanbul ignore else */
        if (this.isLeftLabel) {
            className = this.isCompact
                ? `${LEFT_LABEL} ${LEFT_LABEL_COMPACT}`
                : `${LEFT_LABEL}`;
        }
        /* istanbul ignore else */
        if (this.isDisabled) {
            className += ` ${DISABLED_LABEL}`;
        }
        return className;
    }
    /**
     * Returns the CSS classes for the container element of the date range picker component.
     * @returns {string} The CSS classes for the container element.
     */
    get containerClass() {
        /* istanbul ignore else */
        if (this.isDisabled || this.isReadOnly) {
            return DISABLED_CONTAINER;
        }
        /* istanbul ignore else */
        if (!this.isValid) {
            return this.validationType === BxfFormValidationType.ERROR
                ? INVALID_CONTAINER
                : WARNING_CONTAINER;
        }
        /* istanbul ignore else */
        if (this.isSuccess && this.isValid && this.values?.length === 2) {
            return SUCCESS_CONTAINER;
        }
        return this.isMouseFocus && this.isFocused
            ? `${getFocusCss(this.hasKeyboardFocus)} ${FOCUSED_CONTAINER}`
            : RANGE_PICKER_CONTAINER;
    }
    /**
     * Returns a boolean value indicating whether the date range picker is currently focused.
     * The date range picker is considered focused if it is open or if either the start or end input field is focused.
     * @returns {boolean} A boolean value indicating whether the date range picker is focused.
     */
    get isFocused() {
        return this.isOpen || this.isStartFocused || this.isEndFocused;
    }
    /**
     * Function that returns the left label offset and adjusts the label, instructional text and validation message to align with the input
     * @returns {string} The left label offset in px
     **/
    get leftLabelOffset() {
        return `${getLeftLabelOffset(this.label, this.isCompact, this.isLeftLabel, this.isRequired)}px`;
    }
    /**
     * Sets the icon reference handler.
     * @param el - The HTML element reference.
     */
    calendarButtonRefHandler(el) {
        this.calendarButtonRef = el;
        this.initOverlay();
    }
    /**
     * Sets the date range picker reference handler.
     * @param el - The HTML element reference.
     */
    dateRangePickerRefHandler(el) {
        this.dateRangePickerRef = el;
        el && this.initOverlay();
    }
    /**
     * Stores in input element references for start and end date inputs
     */
    initializeTextInputElements() {
        this.startTextInputElement = this.startDateRef?.querySelector(INPUT);
        this.endTextInputElement = this.endDateRef?.querySelector(INPUT);
    }
    /**
     * Creates a reference of picker's calendar
     * @param el - The HTMLBxfCalendarElement reference.
     */
    calendarRefHandler(el) {
        /* istanbul ignore else */
        if (el) {
            this.calendarRef = el;
            this.initOverlay();
        }
    }
    /**
     * Handles when the start input is focused and blurred and checks for
     * potential newly set values.
     * @param event - The focus/blur event.
     */
    handleStartFocusChange(event) {
        this.isStartFocused = event.type === WindowEventMap.focusChanged;
        /* istanbul ignore else */
        if (!this.isStartFocused) {
            const { value: startValue } = this.startTextInputElement;
            this.emitValueChanged(startValue, this.endValue);
            !isRelativeValue(startValue) &&
                this.shouldCheckValidityOnInputBlur &&
                this.setValidState(startValue, this.endValue);
        }
    }
    /**
     * Handles when the end input is focused and blurred and checks for
     * potential newly set values.
     * @param event - The focus/blur event.
     */
    handleEndFocusChange(event) {
        this.isEndFocused = event.type === WindowEventMap.focusChanged;
        /* istanbul ignore else */
        if (!this.isEndFocused) {
            const { value: endValue } = this.endTextInputElement;
            this.emitValueChanged(this.startValue, endValue);
            !isRelativeValue(endValue) &&
                this.shouldCheckValidityOnInputBlur &&
                this.setValidState(this.startValue, endValue);
        }
    }
    get shouldCheckValidityOnInputBlur() {
        return (!this.isFocused ||
            (!isEmpty(this.startTextInputElement?.value) &&
                !isEmpty(this.endTextInputElement?.value)));
    }
    /**
     * Will open the calendar when middle is clicked
     */
    handleMiddleFocusChange() {
        this.isStartFocused = false;
        this.isEndFocused = false;
        this.isOpen = true;
    }
    /**
     * Gets the value of the input when not focused
     * @param value - The value of the user input
     * @returns {string} The value of the displayed input on blur
     */
    getDisplayValue(value) {
        if (isRelativeValue(value))
            return value;
        const dateMoment = strToMoment(value, this.eventDateSeparator, this.inputDateFormat);
        return dateMoment.isValid() &&
            !isEmpty(value) &&
            !isRelativeValue(value)
            ? dateMoment.format(this.displayDateFormat?.replace(SPACE_REGEX, this.eventDateSeparator))
            : value;
    }
    /**
     * Sets the value of the start input in the date range picker.
     * @param value - The new value for the start input.
     */
    setStartInput(value) {
        if (!isRelativeValue(value)) {
            this.startValue = value;
        }
        else {
            this.startDateRelativeValue = value;
        }
    }
    /**
     * Sets the value of the end input in the date range picker.
     * @param value - The value to set for the end input.
     */
    setEndInput(value) {
        if (!isRelativeValue(value)) {
            this.endValue = value;
        }
        else {
            this.endDateRelativeValue = value;
        }
    }
    /**
     * Function used to handle live validation as the user
     * inputs a start date
     * event - The keyboard event that triggered the input.
     */
    async handleStartInputValidity(event) {
        const { value } = this.startTextInputElement;
        /* istanbul ignore else */
        if (isHelperKeys(event, value))
            return;
        event.stopPropagation();
        /* istanbul ignore else */
        if (validKey(event.key, value, this.inputDateFormat)) {
            this.endTextInputElement?.value &&
                (await this.setValidState(value));
            this.isValid
                ? this.setCalendarValues(value, this.endValue)
                : this.setCalendarValues(null, null);
            !this.isValid && this.invalidInputDate.emit();
            await this.focusEndInput();
        }
        else {
            this.values = [];
        }
    }
    /**
     * Function used to handle live validation as the user
     * inputs an end date
     * event - The keyboard event that triggered the input.
     */
    async handleEndInputValidity(event) {
        const { value } = this.endTextInputElement;
        /* istanbul ignore else */
        if (isHelperKeys(event, value))
            return;
        event.stopPropagation();
        /* istanbul ignore else */
        if (validKey(event.key, value, this.inputDateFormat)) {
            await this.setValidState(this.startValue, value);
            this.setCalendarValues(this.startValue, value);
            !this.isValid && this.invalidInputDate.emit();
        }
        else {
            this.setCalendarValues(this.startValue, null);
        }
    }
    /**
     * Function handles actions of the component when the a
     * footer button is clicked.
     */
    async handleFooterButtonClick(event) {
        const { todayInFooter } = event.detail;
        todayInFooter && this.setIsOpen(false);
        this.calendarFooterClicked.emit();
    }
    /**
     * Removes focus from all other pieces to the component
     * and emits calendar button click event.
     */
    calendarButtonClickHandler() {
        this.calendarButtonClicked.emit();
        this.isStartFocused = false;
        this.isEndFocused = false;
    }
    /**
     * Initializes the overlay for the date picker component.
     * @remarks
     * This method checks if the overlay needs to be initialized and then initializes it with the necessary parameters.
     */
    initOverlay() {
        const overlayProps = {
            host: this.host,
            ref: this.dateRangePickerRef,
            calendarRef: this.calendarRef,
            calendarButtonRef: this.calendarButtonRef,
            overridePlacement: this.overridePlacement,
            shouldOpen: this.shouldOpen,
            shouldClose: this.shouldClose,
            keepMouseFocus: this.keepMouseFocus,
            useFocusVisible: true,
            trigger: this.trigger,
            setIsOpen: this.setIsOpen,
            sourceElementCustomClass: this.sourceElementCustomClass,
            targetElementCustomClass: this.targetElementCustomClass,
            parentContainer: getParentOverlayContainer(this.parentOverlayContainerSelector),
        };
        /* istanbul ignore else */
        !this.overlay && (this.overlay = initOverlay(overlayProps));
    }
    /**
     * Renders the mid label for the date range picker component.
     * @returns JSX.Element representing the mid label.
     */
    renderMidLabel() {
        return (h("div", { class: this.isDisabled
                ? MID_LABEL_CONTAINER_DISABLED
                : MID_LABEL_CONTAINER, onClick: this.handleMiddleFocusChange }, h("span", null, MID_LABEL)));
    }
    /**
     * Shared props between both date inputs
     * @returns {JSX.IntrinsicElements['bxf-date-input']} - Props for bxf-date-input component
     */
    get dateInputProps() {
        return {
            isStandaloneComponent: false,
            separator: this.separator,
            eventDateSeparator: this.eventDateSeparator,
            blurredElement: 'host',
            isValid: this.isValid,
            isDisabled: this.isDisabled,
            isReadOnly: this.isReadOnly,
            keepMouseFocus: this.keepMouseFocus,
            validationType: this.validationType,
            inputDateFormat: this.inputDateFormat,
            displayDateFormat: this.displayDateFormat,
            isDisplayDateAllCaps: this.isDisplayDateAllCaps,
            size: this.size,
            eventData: this.eventData,
            errorMessage: null,
            showInputGuide: this.showInputGuide,
            isTracking: this.isTracking,
            trackingData: this.trackingData,
            namespaceI18n: this.namespaceI18n,
            i18nKeys: this.dateInputI18nKeys,
            ariaDescriptionAttr: this.instructionalText,
            ariaRequiredAttr: this.isRequired,
            onMouseDown: this.mouseDownHandler,
            onKeyDown: this.keyDownHandler,
            onMouseEnter: () => {
                this.inputClicked = true;
            },
            onMouseLeave: () => {
                this.inputClicked = false;
            },
        };
    }
    /**
     * @returns {JSX.IntrinsicElements['bxf-calendar']} - Props for bxf-calendar component
     */
    get calendarProps() {
        return {
            isOverlay: true,
            isRange: true,
            maxDaysSelectable: Infinity,
            separator: this.separator,
            eventDateSeparator: this.eventDateSeparator,
            dateFormat: this.inputDateFormat,
            initActiveMonth: this.initActiveMonth,
            hasSeparatorSettings: this.hasSeparatorSettings,
            hasDateFormatSettings: this.hasDateFormatSettings,
            displayDateFormat: this.displayDateFormat,
            initActiveYear: this.initActiveYear,
            initWithToday: this.initWithToday,
            values: this.values,
            calendarNote: this.calendarNote,
            hasFooterSettings: this.hasFooterSettings,
            settingsSelectData: this.settingsSelectData,
            hasCalendarFooter: this.hasCalendarFooter,
            footerShortcutData: this.footerShortcutData,
            disabledDates: this.disabledDates,
            disableWeekends: false,
            hasTodayInFooter: true,
            hideDatesOutsideActiveMonth: this.hideDatesOutsideActiveMonth,
            keepTodayEnabled: true,
            holidays: this.holidays,
            customDateMarkerA: this.customDateMarkerA,
            customDateMarkerB: this.customDateMarkerB,
            showMarkerPopovers: this.showMarkerPopovers,
            footerLabel: this.footerLabel,
            isCalendarVisible: this.isOpen,
            isHeaderDynamic: true,
            isTodayHighlighted: this.isTodayHighlighted,
            minDateSelectable: this.minDateSelectable,
            maxDateSelectable: this.maxDateSelectable,
            isTracking: this.isTracking,
            trackingData: this.trackingData,
            isMonthSelectDisabled: this.isReadOnly,
            isYearSelectDisabled: this.isReadOnly,
            isDisabled: this.isDisabled,
            filterMonths: this.filterMonths,
            defaultPopoverHeader: this.defaultPopoverHeader,
            hideInactiveDateDetails: this.hideInactiveDateDetails,
            dataTestSuffix: this.dataTestSuffix,
            i18nKeys: this.calendarI18nKeys,
            eventData: this.eventData,
            calendarSettingsI18nKeys: this.calendarSettingsI18nKeys,
            isFooterDisabled: this.isFooterDisabled,
            namespaceI18n: this.namespaceI18n,
        };
    }
    /**
     * Turn focus ring back on when tab pressed in calendar
     * @param event - The keyboard event that triggered the input.
     */
    async keyDownHandler(event) {
        const focusKeys = [
            ...FocusIndexManager.ESC_KEYS,
            ...FocusIndexManager.HORIZONTAL_NAV_KEYS,
            ...FocusIndexManager.VERTICAL_NAV_KEYS,
            KeyboardEventKey.Home,
            KeyboardEventKey.End,
            KeyboardEventKey.Tab,
            KeyboardEventKey.Enter,
        ];
        /* istanbul ignore else */
        if (focusKeys.includes(event.key)) {
            /* istanbul ignore else */
            if (event.key === KeyboardEventKey.Enter) {
                this.isStartFocused = false;
                this.isEndFocused = false;
                this.inputClicked = false;
            }
            this.toggleFocusSource(FocusSource.Keyboard);
        }
        this.handleInputSwitch(event);
    }
    /*
     * Handles the input switch when the user presses the arrow keys or backspace
     * @param event - The keyboard event that triggered the input.
     */
    async handleInputSwitch(event) {
        /* istanbul ignore else */
        if (!this.inputDateFormat.includes(MMMM) &&
            !this.isRelativeStartDate &&
            !this.isRelativeEndDate) {
            const textInputElement = this.isStartFocused
                ? this.startTextInputElement
                : this.endTextInputElement;
            const { selectionStart, selectionEnd } = textInputElement;
            /* istanbul ignore else */
            if (this.isEndFocused &&
                ((isEmpty(this.endTextInputElement?.value) &&
                    event.key === KeyboardEventKey.Backspace) ||
                    (event.key === KeyboardEventKey.ArrowLeft && !selectionEnd))) {
                event.preventDefault();
                /* istanbul ignore else */
                if (!this.endTextInputElement?.value)
                    this.endValue = '';
                await this.focusStartInput();
            }
            else if (this.isStartFocused &&
                selectionStart === this.inputDateFormat.length &&
                event.key === KeyboardEventKey.ArrowRight) {
                event.preventDefault();
                this.startValue = this.startTextInputElement?.value;
                await this.focusEndInput();
            }
        }
    }
    /**
     * Toggle focus source to touch on touchstart in calendar
     */
    touchStartHandler() {
        this.toggleFocusSource(FocusSource.Touch);
    }
    /**
     * Toggle focus source to mouse on mousedown in calendar
     */
    mouseDownHandler() {
        this.toggleFocusSource(FocusSource.Mouse);
    }
    /**
     * Whether or not component focused via mouse
     * @returns {boolean} - Whether or not component focused via mouse
     */
    get isMouseFocus() {
        return this.focusSource !== FocusSource.Keyboard;
    }
    /**
     * Toggle focus source to given value.
     * If value is not keyboard, only change value if keepMouseFocus off
     * @param focusSource - The focus source to toggle to
     */
    toggleFocusSource(focusSource) {
        /* istanbul ignore else */
        if (focusSource === FocusSource.Keyboard) {
            this.focusSource = FocusSource.Keyboard;
        }
        else if (!this.keepMouseFocus) {
            this.focusSource = focusSource;
        }
    }
    /**
     * Get assistive text for start date input:
     * - If this.assistiveText['start'] is set, return it
     * - Otherwise, return "Start [group assistive text]", with appropriate translations
     */
    getStartAssistiveText() {
        return get(this.assistiveText, ASSISTIVE_TEXT_START, `${this.startAssistiveTextFallback} ${this.getGroupAssistiveText()}`);
    }
    /**
     * Get assistive text for end date input:
     * - If this.assistiveText['end'] is set, return it
     * - Otherwise, return "End [group assistive text]", with appropriate translations
     */
    getEndAssistiveText() {
        return get(this.assistiveText, ASSISTIVE_TEXT_END, `${this.endAssistiveTextFallback} ${this.getGroupAssistiveText()}`);
    }
    /**
     * Get assistive text for entire group:
     * - If set to a string: return this.assistiveText if not empty, otherwise return this.label
     * - If set to an object: return this.assistiveText['group'], otherwise fallback to string in "if set to a string"
     */
    getGroupAssistiveText() {
        return typeof this.assistiveText === 'string'
            ? this.assistiveText || this.label
            : get(this.assistiveText, ASSISTIVE_TEXT_GROUP, this.label);
    }
    /**
     * Function that renders the date inputs for the component
     * @param isStartInput - Indicates if the input is for the start date.
     * @returns {JSX.Element} The date inputs for the component
     */
    renderDateInput(isStartInput) {
        // Sets the appropriate properties for the date input based on whether it is the start or end input
        const propVal = (start, end) => isStartInput ? start : end;
        return (h("bxf-date-input", { ...this.dateInputProps, ref: (el) => {
                if (isStartInput) {
                    this.startDateRef = el;
                }
                else {
                    this.endDateRef = el;
                }
            }, key: propVal(this.startInputId, this.endInputId), class: propVal(START_INPUT_CONTAINER, END_INPUT_CONTAINER), assistiveText: propVal(this.getStartAssistiveText(), this.getEndAssistiveText()), inputValue: propVal(this.startValue, this.endValue), dataTestSuffix: createSelector(propVal('00', '01'), this.dataTestSuffix || '', true), isRelativeDate: propVal(this.isRelativeStartDate, this.isRelativeEndDate), keepRelativeDate: propVal(this.keepRelativeStartDate, this.keepRelativeEndDate), relativeDateValue: propVal(this.startDateRelativeValue, this.endDateRelativeValue), textAlign: propVal('left', 'right'), onKeyUp: propVal(this.handleStartInputValidity, this.handleEndInputValidity), onBlurChanged: propVal(this.handleStartFocusChange, this.handleEndFocusChange), onFocusChanged: propVal(this.handleStartFocusChange, this.handleEndFocusChange) }));
    }
    /**
     * Function that renders a success or error message when necessary
     * - Renders the error message when the input is either disabled or failed dev's custom validation, and has a set error message.
     * - Renders the success messages when the input is not disabled, passed dev's custom validation, and has a set success message
     * @returns {JSX.Element | null} - The message to render beneath the input.
     */
    renderMessage() {
        const isInvalid = !this.isValid && !isEmpty(this.errorMessage);
        const isSuccess = this.isSuccess &&
            this.isValid &&
            this.values?.length &&
            !isEmpty(this.successMessage);
        const message = isInvalid ? this.errorMessage : this.successMessage;
        return isInvalid || isSuccess ? (h("div", { style: { paddingLeft: this.leftLabelOffset }, class: this.getMessageCss(isSuccess) }, message)) : null;
    }
    /**
     * Render error or success message in live region
     * 	so that screen readers can announce the message
     */
    renderMessageWrapper() {
        return (h("div", { role: Role.ALERT, "aria-atomic": 'true' }, this.renderMessage()));
    }
    /**
     * Function that handles calendar button
     * @returns {JSX.Element} The calendar button
     */
    renderCalendarButton() {
        const ariaConfig = {
            [AriaAttr.HASPOPUP]: HasPopupValue.DIALOG,
            [AriaAttr.EXPANDED]: String(this.isOpen),
        };
        return (h("div", { key: this.calendarButtonId, class: CALENDAR_BUTTON_CONTAINER }, h("bxf-button", { ref: this.calendarButtonRefHandler, assistiveText: CALENDAR_BUTTON_ASSISTIVE_TEXT, onClick: this.calendarButtonClickHandler, ariaConfig: ariaConfig, type: this.isFocused
                ? BxfButtonTypeEnum.TERTIARY
                : BxfButtonTypeEnum.TERTIARY_SUBTLE, class: CALENDAR_BUTTON, icon: BxfIconTypeEnum.calendar, isDisabled: this.isDisabled || this.isReadOnly, "data-test": createSelector(this.host.tagName, CALENDAR_BUTTON), dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Function that return the instructional text for the date range picker
     * @returns {JSX.Element} The instructional text div element for the date range picker
     **/
    renderInstructionalText() {
        return (h("div", { style: { paddingLeft: this.leftLabelOffset }, "data-test": createSelector(this.host.tagName, INSTRUCTIONAL_TEXT_DATA_TEST), ...(this.instructionalText && {
                class: this.isCompact
                    ? INSTRUCTIONAL_TEXT_COMPACT
                    : INSTRUCTIONAL_TEXT,
            }) }, h("span", { id: this.descriptionId }, this.instructionalText)));
    }
    /**
     * Handles changes to the picker's calendar
     * @param event - The BxfCalendarRangeSelectionChangedDetailInterface event that triggered the change.
     */
    handleCalendarValueChange(event) {
        event.stopPropagation();
        const { startDate, endDate } = event.detail;
        const startValue = this.formatDate(startDate, this.inputDateFormat);
        const endValue = this.formatDate(endDate, this.inputDateFormat);
        this.emitValueChanged(startValue, endValue);
        endValue && this.setValidState(startValue, endValue);
        !this.closeCalendarOnBlur && this.endValue && this.setIsOpen(false);
    }
    /**
     * Function that renders the label for the component
     * @returns {JSX.Element} The label for the component
     */
    renderLabel() {
        /* istanbul ignore else */
        if (!this.label)
            return null;
        const asterisk = this.isRequired && this.label ? (h("div", { class: REQUIRED_LABEL, "aria-hidden": 'true' }, "*")) : null;
        return (h("div", { key: this.labelId, class: this.labelClass }, this.label, asterisk));
    }
    /**
     * Function to make sure that events still output the dev's
     * set date formats, incase changed in the settings by user.
     * @param date - calendar date with format DD MM YYYY (spaces as separators)
     * @returns {string} - The formatted date
     */
    formatDate(date, dateFormat = this.initDateFormat) {
        return date
            ? moment(date, BxfDatePickerDateFormatEnum.DD_MM_YYYY, true).format(dateFormat?.replace(SPACE_REGEX, this.eventDateSeparator))
            : '';
    }
    /**
     * Function that renders the calendar
     * @returns {JSX.Element} The calendar component for the overlay and the calendar button
     */
    renderCalendar() {
        const focusSrcHandlers = this.keepMouseFocus
            ? {}
            : {
                onKeyDown: this.keyDownHandler,
                onMouseDown: this.mouseDownHandler,
                onTouchStart: this.touchStartHandler,
            };
        return (h("div", { key: this.calendarId }, h("bxf-calendar", { ref: this.calendarRefHandler, ...focusSrcHandlers, ...this.calendarProps, onFooterClicked: this.handleFooterButtonClick, onCalendarValueChanged: (e) => {
                e.stopPropagation();
                const value = this.formatDate(e.detail.value);
                this.calendarValueChanged.emit({ ...e.detail, value });
            }, onDateChanged: (e) => {
                e.stopPropagation();
                const date = this.formatDate(e.detail.date);
                this.dateChanged.emit({ ...e.detail, date });
            }, onMonthChanged: (e) => {
                e.stopPropagation();
                this.monthChanged.emit(e.detail);
            }, onYearChanged: (e) => {
                e.stopPropagation();
                this.yearChanged.emit(e.detail);
            }, onCalendarSelected: (e) => {
                e.stopPropagation();
                this.calendarSelected.emit(e.detail);
            }, onRangeDateSelectionChanged: this.handleCalendarValueChange, onSeparatorSelected: (event) => {
                this.separator = event.detail.separator;
            }, onDateFormatSelected: (e) => {
                e.stopPropagation();
                const { dateFormat } = e.detail;
                this.inputDateFormat = dateFormat;
                this.displayDateFormat = dateFormat;
            }, onShortcutClicked: (e) => {
                e.stopPropagation();
                this.calendarShortcutClicked.emit(e.detail);
            }, onTodayButtonMenuItemClicked: (e) => {
                e.stopPropagation();
                e.detail.value &&
                    this.calendarResetButtonMenuItemClicked.emit(e.detail);
            }, parentOverlayContainerSelector: this.parentOverlayContainerSelector })));
    }
    /**
     * Function that renders the error or success message when necessary
     * @param isSuccess - Whether or not the message is a success message or an error message
     * @returns {string} The CSS class for the message rendered beneath the input.
     */
    getMessageCss(isSuccess = true) {
        /* istanbul ignore else */
        if (isSuccess) {
            return SUCCESS_MESSAGE;
        }
        return this.validationType === BxfFormValidationType.ERROR
            ? ERROR_MESSAGE
            : WARNING_MESSAGE;
    }
    /**
     * Renders the input element for the date range picker component.
     * @returns {JSX.Element} The JSX element representing the date input element.
     */
    renderRangePicker() {
        return (h("div", { ref: (el) => this.dateRangePickerRefHandler(el), key: this.rangePickerId, "aria-label": this.getGroupAssistiveText(), role: Role.GROUP, class: this.containerClass, onMouseDown: this.mouseDownHandler }, this.renderDateInput(true), this.renderMidLabel(), this.renderDateInput(false), this.renderCalendarButton()));
    }
    render() {
        return (h("div", { key: 'd301906c883326914096fdec845dcda50e0bcb16', "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, !this.isLeftLabel && this.renderLabel(), this.renderInstructionalText(), h("div", { key: '706019531f5a33acbeef22d3602ca8326cd78c4e', class: LEFT_LABEL_CONTAINER }, this.isLeftLabel && this.renderLabel(), this.renderRangePicker(), this.renderCalendar()), this.renderMessageWrapper()));
    }
    static get watchers() { return {
        "displayDateFormat": ["displayDateFormatChangeHandler"],
        "endValue": ["endValueChangedHandler"],
        "eventDateSeparator": ["eventDateSeparatorChangeHandler"],
        "inputDateFormat": ["inputDateFormatChangeHandler"],
        "isOpen": ["calendarOpenHandler"],
        "maxDate": ["maxDateHandler"],
        "maxYear": ["maxDateHandler"],
        "minDate": ["minDateHandler"],
        "minYear": ["minDateHandler"],
        "separator": ["separatorChangeHandler"],
        "startValue": ["startValueChangedHandler"]
    }; }
};
BxfDateRangePicker.style = BxfDateRangePickerStyle0;

export { BxfDatePicker as bxf_date_picker, BxfDateRangePicker as bxf_date_range_picker };
